module.exports = __webpack_public_path__ + "static/media/water supply.7114fee0.png";